import { useQuery } from "@/common/helpers/ReactHooks";
import { connect } from "react-redux";
import { useEffect, useMemo, useState } from "react";

import { Actions as FSSREPORTACTIONS } from "@/redux/actions/fssReportActions";
import { Actions as ADVISORTAXFORMACTIONS } from "@/redux/actions/advisorTaxFormActions";

import Select from "react-select";
import FssRow from "../../fss-reports/FssRow";

const AdvisorTaxForms = ({ reportTypes, taxFormRows: rows, listFssReports, taxReports, getReports, organisations }) => {
	const [reportType, setReportType] = useQuery("report");

	const selectedReport = reportTypes?.find((r) => r.value == reportType);

	const taxFormRows = useMemo(() => {
		if (selectedReport?.taxFormRows) return selectedReport.taxFormRows;
		return rows;
	}, [reportType]);

	useEffect(() => {
		getReports(reportType);
	}, [reportType]);

	useEffect(() => {
		if (reportTypes && !reportType) setReportType(reportTypes[0]?.value);
	}, [reportTypes?.length]);

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Tax Forms</h1>
						</div>
					</div>
				</div>
			</div>

			<div className="content">
				<div className="col-xs-4 pl-0">
					<label htmlFor="material-text">Tax Form</label>
					<Select
						value={selectedReport}
						options={reportTypes}
						onChange={(selected) => {
							setReportType(selected.value);
						}}
					/>
					<div className="clearfix" />
				</div>
			</div>

			<div className="clearfix" />

			{taxReports && (
				<div className="content">
					<div style={{ overflow: "auto" }}>
						<table
							id="table-timesheets"
							className="js-table-sections table table-hover"
						>
							<thead>
								<tr>
									<th style={{ width: "5%" }}></th>
									<th>Organisation</th>
									<th>Name</th>
									{taxFormRows?.map((row, index) => {
										return <th key={row.label}>{row.label}</th>;
									})}
									{reportType == "fs3" && <th>Portal Access</th>}
									<th></th>
								</tr>
							</thead>
							<tbody>
								{taxReports.map((taxReport) => {
									return (
										<FssRow
											key={taxReport.index}
											{...{
												fssReport: taxReport,
												reportType,
												taxFormRows,
											}}
											advisor={true}
										/>
									);
								})}
							</tbody>
						</table>
					</div>
				</div>
			)}
		</>
	);
};

const mapStateToProps = (state) => {
	const jurisdiction = state.advisors?.settings?.jurisdiction;
	const jurisdictionObject = state?.jurisdictions?.find((j) => j.countryCode == (jurisdiction));
	return {
		reportTypes: jurisdictionObject?.taxForms?.filter(r => r?.for?.includes?.("advisor")),
		taxFormRows: jurisdictionObject?.taxFormRows,
		taxReports: state.advisors?.taxReports,
		organisations: state?.organisations,
	};
};

const mapDispatchToProps = (dispatch) => ({
	listFssReports: (data) => dispatch(FSSREPORTACTIONS.listFssReports(data)),
	getReports: (data) => dispatch(ADVISORTAXFORMACTIONS.advisorTaxFormGetReports(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorTaxForms);
